var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "79-users",
    id: "_79-users"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 13,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,28A7,7,0,0,0,9,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,14a5,5,0,1,0-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,24h6a7,7,0,0,0-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6a5,5,0,1,0-4,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,17a7,7,0,0,0-7,7H7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPatientsIcon);
export default __webpack_public_path__ + "static/media/total-patients-icon.3f5721ec498095cefda8c1d3ec3c85b6.svg";
export { ForwardRef as ReactComponent };